<template>
  <div class="productTags">
    <product-tag
      v-for="(tag, index) in tags"
      :key="index"
      :color="tag.color"
      :name="tag.name"
      :value="tag.value"
      class="productTags__tag"
    />
  </div>
</template>

<script>
import ProductTag from './ProductTag';
export default {
  name: 'ProductTags',
  components: { ProductTag },
  props: {
    tags: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.productTags {
  margin-bottom: 1rem;
  margin-left: -1rem;
  margin-right: -1rem;

  @include rwd('small-tablet') {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  &__tag {
    padding-left: 1rem;
    padding-right: 1rem;
    border-left: 1px solid $cAddLight;

    @include rwd('small-tablet') {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }

    &:first-child {
      border-left: 0;
    }
  }
}
</style>
